import { createAction, props } from '@ngrx/store';
import dayjs from 'dayjs';
import { Ticket, TicketEntitlement } from '../../../core/api/responses/booking-portal-login';
import { EventCalendar } from '../models/event-calendar.model';

/**
 * Booking information returned from BookingPortalLogin
 */
export const bookingReceived = createAction(
	'[Api Effects] Booking Received',
	props<{ orderId: string; tickets: Ticket[]; swFailedCount?: number }>()
);

export const setOpenEntitlement = createAction(
	'[Entitlement Component] Set Open Entitlement',
	props<{ ticket: Ticket; entitlement: TicketEntitlement }>()
);

export const setNewBookingDateTime = createAction(
	'[Modify Component] Set New Booking Date and Time on Open Entitlement',
	props<{ newDate: dayjs.Dayjs; newTime?: string }>()
);

export const clearOpenEntitlement = createAction('[Modify Component] Clear Open Entitlement');

export const eventDataReceived = createAction(
	'[Bookings Effects] Event Data Received',
	props<{ event: EventCalendar }>()
);

export const addEditBookingFailed = createAction('[Bookings Effects] Add/Edit Booking Failed');

export const clearEventDates = createAction('[Modify Component] Clear Event Dates');

export const resetSwFailedCount = createAction('[Modify Component] Reset Sw Failed Count');
